import React, { useContext } from 'react';
// import { Redirect } from 'react-router-dom';
// import { PermissionButton, WhiteButton } from '../NoPermission/styles';
// import cam from '../../../assets/frame.svg';
// import { StandartPage } from '../../design/StandartPage';
// import { Container } from '../../design/Container';
// import { sendMessageToParent } from '../../utils';
// import RootContext from '../../context';
// import { PATH_INTRO, PATH_ROOT } from '../../paths';

export const NoCamera = () => {
  // const { videoParams } = useContext(RootContext);
  // if (!videoParams) return <Redirect to={`${PATH_ROOT}${PATH_INTRO}`}/>;
  // const buttons = <Container>
  //   <WhiteButton onClick={() => sendMessageToParent({ _: 'cancel' })}>
  //     Cancel
  //   </WhiteButton>
  //   <PermissionButton onClick={() => sendMessageToParent({ _: 'restart' })}>
  //     Grant access to camera
  //   </PermissionButton>
  // </Container>;

  return (
    <>
      no camera
    </>
  );
};

/*
      <StandartPage
        image={cam}
        title={'Sorry, but we can’t find your camera'}
        underText={'Check to make sure it’s connected and installed Connected properly, that it isn’t affected by any software'}
        buttons={buttons}
      />

 */
